webpackJsonp([38848974801413],{

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(11);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spotifyAuth = __webpack_require__(58);
	
	var _queryParams = __webpack_require__(217);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SpotifyAuthCallback = function (_React$Component) {
	  _inherits(SpotifyAuthCallback, _React$Component);
	
	  function SpotifyAuthCallback() {
	    _classCallCheck(this, SpotifyAuthCallback);
	
	    if ((0, _queryParams.getParameterByName)('auto_login')) {
	      (0, _spotifyAuth.authSpotify)();
	    }
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  SpotifyAuthCallback.prototype.render = function render() {
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        "div",
	        {
	          className: "jsx-2014292207" + " " + "hero"
	        },
	        _react2.default.createElement(
	          "h2",
	          {
	            className: "jsx-2014292207"
	          },
	          "Please login to continue"
	        ),
	        _react2.default.createElement(
	          "button",
	          { onClick: function onClick() {
	              return (0, _spotifyAuth.authSpotify)(true);
	            }, className: "jsx-2014292207" + " " + "spotify-login"
	          },
	          "Login to Spotify"
	        )
	      ),
	      _react2.default.createElement(_style2.default, {
	        styleId: "2014292207",
	        css: [".hero.jsx-2014292207{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;-webkit-flex-flow:column nowrap;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;min-height:45vh;height:100px;}", "button.spotify-login.jsx-2014292207{font-size:1em;background:#84BD00;color:white;border-radius:50px;width:500px;min-height:60px;margin-top:50px;cursor:pointer;}"]
	      })
	    );
	  };
	
	  return SpotifyAuthCallback;
	}(_react2.default.Component);
	
	exports.default = SpotifyAuthCallback;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-spotifyauth-js-fb009924ecd6473fc150.js